import { css } from '@genesislcap/web-core';

export const CombinedRatingsStyles = css`
  :host {
    display: block;
  }

  .ag-set-filter-list {
    overflow-y: auto;
  }
`;
